module.exports = __webpack_public_path__ + "static/media/ALIANZA BRA-22.9395f20f.png";